/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Chat_Recap_Card_TitleInputs */



/**
* | output |
* | --- |
* | "Summary of the previous conversation — {date}" |
*
* @param {Chat_Recap_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_recap_card_title = /** @type {((inputs: Chat_Recap_Card_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Recap_Card_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Samenvatting vorig gesprek — ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Résumé de la conversation précédente — ${i?.date}`)
	return /** @type {LocalizedString} */ (`Summary of the previous conversation — ${i?.date}`)
});